import { IVIRoute } from '@web/app/routing/interfaces';

export interface IVIEdgeLiveRoutesMap {
  cameras: IVIRoute;
  camerasInLocation: IVIRoute;
  cameraManagement: IVIRoute;
  mediaFiles: IVIRoute;
  presets: IVIRoute;
  cameraPage: IVIRoute;
  cameraLiveStreamTab: IVIRoute;
  cameraRecordingsTab: IVIRoute;
  cameraMediaFile: IVIRoute;
  customModels: IVIRoute;
  alertRules: IVIRoute;
}

export const VIEdgeLiveRoutingMap: IVIEdgeLiveRoutesMap = {
  cameras: {
    name: 'Edge Live Cameras',
    traceName: 'edge_extension.live.cameras',
    path: 'cameras'
  },
  camerasInLocation: {
    name: 'Edge Live Cameras In Location',
    traceName: 'edge_extension.live.cameras_in_location',
    path: 'locations/:locationId/cameras'
  },
  cameraManagement: {
    name: 'Edge Live Camera Management',
    traceName: 'edge_extension.live.cameras_management',
    path: 'cameras-management'
  },
  mediaFiles: {
    name: 'Edge Live Media Files',
    traceName: 'edge_extension.live.media_files',
    path: 'media-files'
  },
  cameraMediaFile: {
    name: 'Edge Live Camera Media File',
    traceName: 'edge_extension.live.camera_media_file',
    path: 'cameras/:cameraId/videos/:videoId'
  },
  presets: {
    name: 'Edge Live Presets',
    traceName: 'edge_extension.live.presets',
    path: 'presets'
  },
  customModels: {
    name: 'Edge Live Custom Models',
    traceName: 'edge_extension.live.custom_models',
    path: 'custom-models'
  },
  cameraPage: {
    name: 'Edge Live Camera Page',
    traceName: 'edge_extension.live.camera_page',
    path: 'cameras/:cameraId'
  },
  cameraLiveStreamTab: {
    name: 'Edge Live Camera Page Live Stream Tab',
    traceName: 'edge_extension.live.camera_page.live_stream',
    path: 'cameras/:cameraId/live-stream'
  },
  cameraRecordingsTab: {
    name: 'Edge Live Camera Page Recordings Tab',
    traceName: 'edge_extension.live.camera_page.recordings',
    path: 'cameras/:cameraId/recordings'
  },
  alertRules: {
    name: 'Edge Live Alert Rules',
    traceName: 'edge_extension.live.alert_rules',
    path: 'alert-rules'
  }
};
